// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._3lYzYbUs82Ot66nGmyJPLQ {\n    flex: 1;\n    text-align: center;\n}\n\n._2-sPYXum_CAObppeZO9Fb0 {\n    text-align: center;\n    font-size: 24px;\n    line-height: 1.5;\n}\n", ""]);
// Exports
exports.locals = {
	"content": "_3lYzYbUs82Ot66nGmyJPLQ",
	"heading": "_2-sPYXum_CAObppeZO9Fb0"
};
module.exports = exports;
